import React, { useState, useEffect } from "react";
import CalendarComponent from "../../components/CalendarComponent/CalendarComponent";
import CalendarFilters from "../../components/CalendarFilters/CalendarFilters";
import {
  MyCalendarContent,
  LiveEvent,
  EventDetail,
  ContentLives,
  MessageNoEvents,
  MyCalendar,
  RightSection,
} from "./MyCalendarContainer.styled";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import TimeCounter from "../../components/TimeCounter/TimeCounter";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import Skeleton from "@mui/material/Skeleton";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { useHistory } from "react-router-dom";
import {
  ALL_CATEGORIES_CALENDAR,
  EVENT_CALENDAR_FILTERED,
  FIRTS_LIVE_EVENTS_CALENDAR,
  AFTER_LIVE_EVENTS_CALENDAR,
} from "../../GraphQL/Queries";
import { theme as themeConfig } from "../../themes/themes";
import { useLazyQuery } from "@apollo/client";
import { clientWellness } from "../../App";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import HeaderComponent from "../../components/Header/Header";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-header-icon.svg";
import moment from "moment";

const MyCalendarContainer = () => {
  const [categories, setCategories] = useState([]);
  const [liveEvents, setLiveEvents] = useState([]);
  const [value, setValue] = useState(0);
  const [categoriesList, setCategoriesList] = useState([]);
  const [myEventsList, setMyEventsList] = useState([]);
  const [user] = useState(getStateLoginComplete());
  const [liveEventsdata, setLiveEventsdata] = useState([]);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [cursor, setCursor] = useState("");
  const history = useHistory();
  const [startSearch] = useState(new Date(`${new Date().getFullYear()}/01/01`));
  const [endSearch] = useState(
    new Date(
      new Date(`${new Date().getFullYear()}/01/31`).setMonth(
        new Date().getMonth() + 11
      )
    )
  );

  const [runQueryGetEventsFiltered, { loading: loadingEventsFiltered }] =
    useLazyQuery(EVENT_CALENDAR_FILTERED, {
      client: clientWellness,
      fetchPolicy: "network-only",

      onCompleted: (data) => {
        let Events = [];
        data.myCalendar.map((m) => {
          let pos = m.wellnessParticipants.findIndex(
            (f) => f.userId == user.userId
          );
          let dto = {
            id: m.idEvent,
            title: m.eventName,
            start: new Date(m.startDate),
            end: new Date(m.finishDate),
            hexColor:
              m.wellnessParticipants[pos].attendStatus == "Accept"
                ? m.idCategoryNavigation.codeColor
                : m.idCategoryNavigation.codeColor + "66",
            categoryName: m.idCategoryNavigation.categoryName,
            status: m.wellnessParticipants[pos].attendStatus,
          };
          Events.push(dto);
        });
        setMyEventsList(Events);
      },
    });
  const [runQueryGetCategories] = useLazyQuery(ALL_CATEGORIES_CALENDAR, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setCategoriesList(data.allCategories);
      let categories = data?.allCategories.map((category) => {
        return category?.idCategory;
      });
      setCategories(categories);
    },
  });
  const [GetFirtsLiveEvents, { loading: loadingEvents }] = useLazyQuery(
    FIRTS_LIVE_EVENTS_CALENDAR,
    {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setCursor(data.allEvents.pageInfo.endCursor);
        let dto = [];
        data.allEvents.edges.map((m) => {
          let data = {
            idEvent: m.node.idEvent,
            name: m.node.eventName,
            start: new Date(m.node.startDate),
            end: new Date(m.node.finishDate),
          };
          dto.push(data);
        });
        setLiveEventsdata(dto);
      },
    }
  );
  const [GetNextLiveEvents] = useLazyQuery(AFTER_LIVE_EVENTS_CALENDAR, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setCursor(data.allEvents.pageInfo.endCursor);
      setHasNextPage(data.allEvents.pageInfo.hasNextPage);
      if (data.allEvents.edges.length) {
        let dto = JSON.parse(JSON.stringify(liveEventsdata));
        data.allEvents.edges.map((m) => {
          let data = {
            idEvent: m.node.idEvent,
            name: m.node.eventName,
            start: new Date(m.node.startDate),
            end: new Date(m.node.finishDate),
          };

          dto.push(data);
        });
        setLiveEventsdata(dto);
      }
    },
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <div>{children}</div>}
      </div>
    );
  }

  const categoriesFiltered = (obj) => {
    const allCategories = [...categories];
    const pos = allCategories.findIndex((f) => f === obj.idCategory);
    if (pos === -1) {
      allCategories.push(obj.idCategory);
    } else {
      allCategories.splice(pos, 1);
    }
    setCategories([...allCategories]);
    if (allCategories.length > 0) {
      runQueryGetEventsFiltered({
        variables: {
          idCategory: allCategories,
          userId: user.userId,
          startSearch: startSearch,
          endSearch: endSearch,
        },
      });
    } else {
      runQueryGetEventsFiltered({
        variables: {
          idCategory: [],
          userId: user.userId,
          startSearch: startSearch,
          endSearch: endSearch,
        },
      });
    }
  };

  const handleScroll = ({ currentTarget }) => {
    if (
      currentTarget.scrollTop + currentTarget.clientHeight >=
      currentTarget.scrollHeight &&
      hasNextPage
    ) {
      GetNextLiveEvents({
        variables: {
          userId: user.userId,
          first: 10,
          after: cursor,
          startDate: new Date().toUTCString(),
          finishDate: new Date().toUTCString(),
        },
      });
    }
  };

  useEffect(() => {
    runQueryGetCategories();
    GetFirtsLiveEvents({
      variables: {
        first: 10,
        userId: user.userId,
        startDate: new Date().toUTCString(),
        finishDate: new Date().toUTCString(),
      },
    });
  }, []);

  useEffect(() => {
    console.log("categoriesList", categoriesList)
    if (categoriesList.length > 0) {
      let categoriesId = categoriesList.map((element) => {
        return element.idCategory;
      });
      runQueryGetEventsFiltered({
        variables: {
          idCategory: categoriesId,
          userId: user.userId,
          startSearch: startSearch,
          endSearch: endSearch,
        },
      });
    }
  }, [categoriesList]);

  useEffect(() => {
    let liveEventsdataDTO = JSON.parse(JSON.stringify(liveEventsdata));
    liveEventsdataDTO.map((m) => {
      m.start = new Date(m.start);
      m.end = new Date(m.end);

      let cantMinutes =
        Math.floor(((m.end - m.start) % 86400000) / 3600000) * 60 +
        Math.floor((((m.end - m.start) % 86400000) % 3600000) / 60000);
      let cantMinutesCurrent =
        Math.floor(((new Date() - m.start) % 86400000) / 3600000) * 60 +
        Math.round((((new Date() - m.start) % 86400000) % 3600000) / 60000);
      m.percentProgress = (cantMinutesCurrent * 100) / cantMinutes;
      m.totalMinutes = cantMinutes;
      m.totalCurrentMinutes = cantMinutesCurrent;
    });
    setLiveEvents(liveEventsdataDTO);
  }, [liveEventsdata]);

  useEffect(() => {
    console.log("myEventsList", myEventsList)
  }, [myEventsList])

  return (
    <MyCalendar>
      <HeaderComponent Icon={CalendarIcon} text={"My calendar"} />
      <MyCalendarContent>
        <CalendarComponent
          heightCalendar={"82vh"}
          events={myEventsList}
        ></CalendarComponent>
        <RightSection>
          <CalendarFilters
            categories={categoriesList}
            categoriesFiltered={categoriesFiltered}
          ></CalendarFilters>
          <div className="liveContent">
            <Paper
              square
              style={{
                marginBottom: "17px",
                boxShadow: "none",
                width: "100%",
                backgroundColor: themeConfig.neutral.gray[1000],
              }}
            >
              <AntTabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
              >
                <AntTab
                  label="Live Events"
                  id="simple-tab-0"
                  valueTabs={value}
                  aria-controls="simple-tabpanel-0"
                />
                {/* <AntTab label="Suggested" id="simple-tab-1" aria-controls="simple-tabpanel-1"/> */}
              </AntTabs>
            </Paper>

            <TabPanel value={value} index={0}>
              <ContentLives
                onScroll={(e) => {
                  handleScroll(e);
                }}
              >
                {loadingEvents &&
                  [1, 2, 3].map((m) => (
                    <Skeleton
                      key={m}
                      variant="rectangular"
                      style={{
                        width: "14vw",
                        marginLeft: "12px",
                        height: "8em",
                      }}
                    />
                  ))}
                {liveEvents.length == 0 && !loadingEvents && (
                  <MessageNoEvents>
                    There are no live events at the moment
                  </MessageNoEvents>
                )}
                {liveEvents
                  .sort((a, b) => {
                    return a.percentProgress - b.percentProgress;
                  })
                  .map((m, i) => {
                    let HoursStart = moment(m.start)
                      .utc()
                      .format("hh:mm a")
                      .toString();
                    let HoursEnd = moment(m.end)
                      .utc()
                      .format("hh:mm a")
                      .toString();

                    return (
                      <LiveEvent key={i}>
                        <Tooltip arrow placement="top" title={m.name}>
                          <EventDetail>
                            <label>
                              {m.name.substr(0, 20)}
                              {m.name.length > 20 ? "..." : ""}
                            </label>
                            <span>
                              <WatchLaterIcon />
                              {HoursStart} to {HoursEnd}
                            </span>
                            <TimeCounter time={m} />
                          </EventDetail>
                        </Tooltip>
                        <div style={{ display: "flex", alignItems: "end" }}>
                          <button className="view-event-btn">
                            <ArrowForwardIcon
                              onClick={() => {
                                history.push({
                                  pathname: `/DetailEvent`,
                                  state: {
                                    idEvent: m.idEvent,
                                    event: m,
                                    path: `/MyCalendar`,
                                  },
                                });
                              }}
                              style={{ fill: themeConfig.text.primary, cursor: "pointer" }}
                            />
                          </button>
                        </div>
                      </LiveEvent>
                    );
                  })}
              </ContentLives>
            </TabPanel>
            {/* <TabPanel value={value} index={1}>
                
            </TabPanel> */}
          </div>
        </RightSection>
        {loadingEventsFiltered && <ModalLoader></ModalLoader>}
      </MyCalendarContent>
    </MyCalendar>
  );
};
export default MyCalendarContainer;
